<template>
  <el-popover :append-to-body="false" placement="bottom-end" width="228" trigger="click" ref="poppver">
    <div class="BSetColumn-vaule">
      <div v-if="fixedLeftNewColumn.length > 0">
        <div class="fixed-title" style="margin-top: 10px">固定列首</div>
        <draggable
          element="ul"
          v-model="fixedLeftNewColumn"
          @update="publicHandle()"
        >
          <div
            v-for="column in fixedLeftNewColumn"
            :key="column.label"
            class="fixed-column"
          >
            <div>
              <span class="drag-icon"
                ><i class="iconfont icon-drag-header"></i
              ></span>
              <el-checkbox
                :label="column.label"
                v-model="column.show"
                @change="publicHandle()"
                :disabled="column.disabled"
              >
                <my-tooltip :content="column.label" placement="top">
                  <span class="column-lable">
                    {{ column.label }}
                  </span>
                </my-tooltip>
              </el-checkbox>
            </div>
            <div class="fixed-column-end" v-if="!column.disabled">
              <el-tooltip
                class="item"
                effect="dark"
                content="不固定"
                placement="top-start"
              >
                <span @click="notFixed(column, 'left')" class="icon">
                  <i class="iconfont icon-juzhong"></i>
                </span>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="固定在列尾"
                placement="top-start"
              >
                <span @click="fixedRight(column, 'left')" class="icon">
                  <i class="iconfont icon-zhidi"></i>
                </span>
              </el-tooltip>
            </div>
          </div>
        </draggable>
      </div>
      <div v-if="notFixedNewColumn.length > 0">
        <div class="fixed-title">非固定项</div>
        <draggable
          element="ul"
          v-model="notFixedNewColumn"
          @update="publicHandle()"
        >
          <div
            v-for="column in notFixedNewColumn"
            :key="column.label"
            class="fixed-column"
          >
            <div>
              <span class="drag-icon"
                ><i class="iconfont icon-drag-header"></i
              ></span>
              <el-checkbox
                :label="column.label"
                v-model="column.show"
                @change="publicHandle()"
                :disabled="column.disabled"
              >
                <my-tooltip :content="column.label" placement="top">
                  <span class="column-lable">
                    {{ column.label }}
                  </span>
                </my-tooltip>
              </el-checkbox>
            </div>
            <div class="fixed-column-end" v-if="!column.disabled">
              <el-tooltip
                class="item"
                effect="dark"
                content="固定在列首"
                placement="top-start"
              >
                <span @click="fixedLeft(column, 'noFixed')" class="icon">
                  <i class="iconfont icon-zhiding"></i>
                </span>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="固定在列尾"
                placement="top-start"
              >
                <span @click="fixedRight(column, 'noFixed')" class="icon">
                  <i class="iconfont icon-zhidi"></i>
                </span>
              </el-tooltip>
            </div>
          </div>
        </draggable>
      </div>
      <div v-if="fixedRightNewColumn.length > 0">
        <div class="fixed-title">固定列尾</div>
        <draggable
          element="ul"
          v-model="fixedRightNewColumn"
          @update="publicHandle()"
        >
          <div
            v-for="(column, index) in fixedRightNewColumn"
            :key="column.label"
            class="fixed-column"
          >
            <div>
              <span class="drag-icon"
                ><i class="iconfont icon-drag-header"></i
              ></span>
              <el-checkbox
                :label="column.label"
                v-model="column.show"
                @change="publicHandle()"
                :disabled="column.disabled || index == fixedRightNewColumn.length - 1"
              >
                <my-tooltip :content="column.label" placement="top">
                  <span class="column-lable">
                    {{ column.label }}
                  </span>
                </my-tooltip>
              </el-checkbox>
            </div>
            <div
              class="fixed-column-end"
              v-if="(!column.disabled) && (index != fixedRightNewColumn.length - 1)"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="不固定"
                placement="top-start"
              >
                <span @click="notFixed(column, 'right')" class="icon">
                  <i class="iconfont icon-juzhong"></i>
                </span>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="固定在列首"
                placement="top-start"
              >
                <span @click="fixedLeft(column, 'right')" class="icon">
                  <i class="iconfont icon-zhiding"></i>
                </span>
              </el-tooltip>
            </div>
          </div>
        </draggable>
      </div>
      <div @click="reset" class="reset">重置</div>
    </div>
    <el-button type="text" class="btn" slot="reference">
      <i
        class="iconfont icon-menu-18"
        style="fontsize: 20px; cursor: pointer; "
      ></i
    ></el-button>
  </el-popover>
</template>

<script>
import draggable from "vuedraggable";
import MyTooltip from "../MyTooltip.vue";
import { openApi } from "./services";
export default {
  components: {
    draggable,
    MyTooltip,
  },
  name: "BSetColumn",
  props: {
    columns: Array,
    headerAlign: String,
    align: String,
    tableNumber: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      checkAll: true,
      checkedColumn: [],
      allColumn: [],
      fixedLeftNewColumn: [],
      fixedRightNewColumn: [],
      notFixedNewColumn: [],
      resetNewColumn: [],
    };
  },
  mounted() {
    this.$refs.poppver.$refs.popper.style.padding = "0px";
  },
  methods: {
    reset() {
      let that = this;
      this.$emit("resetColumn");
      setTimeout(()=>{
        that.publicHandle();
      },100)
    },
    fixedLeft(column, val) {
      column.fixed = "left";
      this.publicHandle();
    },
    fixedRight(column, val) {
      column.fixed = "right";
      this.publicHandle();
    },
    notFixed(column, val) {
      column.fixed = 'middle';
      this.publicHandle();
    },
    publicHandle() {
      let arr = [
        ...this.fixedLeftNewColumn,
        ...this.notFixedNewColumn,
        ...this.fixedRightNewColumn,
      ];
      this.$emit("changeColumn", arr);

      let o = arr.map((item) => {
        return {
          field: item.field,
          fixed: item.fixed,
          show: item.show == true ? "1" : "0",
        };
      });

      // let o = this.columns.map((item) => {
      //   return {
      //     field: item.field,
      //     fixed: item.fixed,
      //     show: item.show == true ? "1" : "0",
      //   };
      // });
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        let { obj } = openApi.saveTableHeader({
          busiCode: window.location.pathname + this.tableNumber,
          columns: o,
        });
      }, 1000);
    },
  },
  watch: {
    columns(newVal, oldVal) {
      this.notFixedNewColumn = this.columns.filter((item) => {
        return (item.fixed == null || item.fixed == 'middle');
      });
      this.fixedRightNewColumn = this.columns.filter((item) => {
        return item.fixed == "right";
      });
      this.fixedLeftNewColumn = this.columns.filter((item) => {
        return item.fixed == "left";
      });
      
    },
  },
};
</script>
<style lang="scss" scoped>
.tool-icon {
  font-size: 20px;
}
.BSetColumn-vaule {
  max-height: 300px;
  overflow: scroll;
  .fixed-title {
    font-size: 12px;
    color: #a3a9b7;
    height: 20px;
    line-height: 24px;
    margin-left: 14px;
    margin-top: 8px;
  }
  .reset {
    color: #3369ff;
    text-align: right;
    padding-right: 14px;
    border-top: 1px solid #dbdeea;
    padding-top: 8px;
    cursor: pointer;
    margin-top: 8px;
    margin-bottom: 10px;
  }
  .fixed-column {
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .column-lable {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100px;
      display: inline-block;
      position: relative;
      top: 6px;
    }
    .fixed-column-end {
      display: none;
      margin-right: 10px;
      .icon {
        &:hover {
          color: #3369ff;
        }
      }
    }
    &:hover {
      background: #ecf3ff;
      .fixed-column-end {
        display: block;
      }
    }
    .drag-icon {
      margin-right: 4px;
      margin-left: 14px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Table/BSetColumn.vue